export enum PaintStep {
  Project = 0,
  Bought = 1,
  Unassembled = 2,
  Assembled = 3,
  Primed = 4,
  Painted = 5,
  Based = 6,
}
